import PersonSearch from '../src/PersonSearch/index.tsx';
export default PersonSearch;
